import { SectionLabel } from "../SectionLabel";
import { StatInsightCard } from "./StatInsightCard";

const stats = [
  {
    percentage: "80",
    title: "Discover New Businesses",
    description:
      "An offer is the ultimate introduction. It removes hesitation, making it the fastest way to acquire first-time customers.",
  },
  {
    percentage: "48",
    title: "Expect Special Offers",
    description:
      "Modern shoppers actively seek value. Publishing deals keeps you competitive and prevents losing customers to the business next door.",
  },
  {
    percentage: "38",
    title: "Spend More Per Visit",
    description:
      "Coupons don’t shrink margins—they encourage higher spending and larger basket sizes.",
  },
];

export const WhyCouponsWorkSection = () => {
  return (
    <section className="w-full px-[16px] sm:px-6 lg:px-[80px] pt-16 lg:pt-[112px]">
      <div className="mx-auto w-full max-w-[1620px] text-center">
        <SectionLabel>Real Buying Signals</SectionLabel>

        <h2 className="mt-6 lg:mt-12 text-[#171717] font-normal leading-[1.2] tracking-[-1.5px] text-[32px] sm:text-[44px] lg:text-[64px]">
          Why Coupons Work
        </h2>

        <p className="mt-[16px] lg:mt-8 mx-auto max-w-[760px] text-[#2A2A2A] text-[15px] lg:text-[20px] leading-[1.4]">
          The data speaks for itself. Coupons don't just attract foot traffic—they influence buying decisions, drive
          local discovery, and increase total spend.
        </p>

        <div className="mt-10 lg:mt-14 grid grid-cols-1 md:grid-cols-3 gap-[16px] lg:gap-9 text-left">
          {stats.map((stat) => (
            <StatInsightCard key={stat.title} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
};
